<template>
  <div class="breadcrumb">
    <ul>
      <li
      v-for="(breadcrumb, idx) in breadcrumbList" :key="idx"
      @click="routeTo(breadcrumb)"
      :class="{'linked': breadcrumb.link}">

      {{ breadcrumb.name }}

      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'Breadcrumb',
    data() {
      return {
          breadcrumbList: [],
          dynamicValue:'',
          createFormTitle:''
      }
    },
    mounted () { this.updateList() },
    created () {
      this.$root.$on('breadcrumb-dynamic-value',(value)=>{
        this.dynamicValue = value
        this.updateList()
      })

      this.$root.$on('breadcrumb-create-form',(value)=>{
        this.createFormTitle = value
      })
    },
    watch: { '$route' () { this.updateList() } },
    methods: {
      routeTo (breadcrumb) {
        if (breadcrumb.link){
          if(breadcrumb.link.includes('/:id?')){
            // console.log('this.$route.query.id: ' + this.$route.query.id)
            let path = '/' + breadcrumb.link.replace('/:id?','')
            this.$router.push({path: path, query: {id: this.$route.query.id}}).catch(err => {})
            return
          }
          this.$router.push('/'+breadcrumb.link).catch(err => {})
        }
      },
      updateList () { 
        this.breadcrumbList = JSON.parse( JSON.stringify( this.$route.meta.breadcrumb ) )
        if (this.$route.params.hasOwnProperty('id')&& typeof(this.$route.params.id)!='undefined') {
          this.breadcrumbList.push({name: this.dynamicValue})
          this.dynamicValue = ''
        }
        if(this.createFormTitle){
          this.breadcrumbList.push({name: this.createFormTitle})
          this.createFormTitle = ''
        }
        console.log("this.breadcrumbList = ",this.breadcrumbList)
      }
    }
  }
</script>

<style scoped>
  .breadcrumb {
    margin-left: 5%;
  }
  ul {
    display: flex;
    list-style: none;
    padding: 0;
    font-size: font(1);
  }
  li {
    /*cursor: pointer;*/
    color: #FFF;
  }
  li:last-child {
    color: #FFF;
    /*cursor: pointer;*/
  }
  li:not(:last-child):after {
      content: ">";
      margin: 5px;
  }
  li.linked{cursor: pointer;}
</style>